import {custom} from 'devextreme/ui/dialog';
import {REPORTS_URL} from '../config/constants';

export function showReports() {
	let dialog =
		custom({
			showTitle: false,
			messageHtml: "<div style='padding: 30px 30px 10px 30px'><p>You are being directed to Tableau.</p><p>If you don't have access, please contact <a href='mailto:sales@sagesurfaces.com'>sales@sagesurfaces.com</a>.</p></div>",
			buttons: [
				{
					text: "OK",
					onClick: () => { return true; }
				},
				{
					text: "Cancel",
					type: 'normal',
					onClick: () => { return false; }
				}]
		});

	dialog.show().then((dialogResult: boolean) => {
		if (dialogResult)
			window.open(REPORTS_URL);
		else
			dialog.hide();
	});
}
